import { css } from 'lit-element';

export const SharedStyles = css`
  .card-header{
    background: slategray;
  }
  .card-header-title{
    color: white;
  }

  .visible {
    display: block;
  }
  .hidden {
    display: none;
  }

  .panel {
    margin-bottom: 1.5rem;
  }

`;